<template>
<div>
    <base-header v-once pageName="상품 검색" :popup="true"></base-header>
    
    <section id="wrap">
<!--         
        <swiper class="swiper slideMenu" :options="slideMenu" ref="prdoMenu">
            <swiper-slide v-for="(item, index) in cateList" :key="index">{{item.cdNm}}</swiper-slide>
        </swiper> -->
       
        <div class="product-search">
                
            <swiper class="swiper category" :options="slideMenu" ref="slide">
                <swiper-slide v-for="(item, index) in cateList" :key="index">
                    <em @click="catChoose(item,index)" :class="[ index == catIdx ? 'current' : null]">
                        {{item.cdNm}}
                    </em>
                </swiper-slide>
            </swiper>

            <!--p class="symbol">북시네마</p-->
            
            <div class="wrap">
                <div class="title">
                    <strong>{{cate.cdNm}}</strong>
                </div>
                <div class="list">
                    <button
                    v-for="(prod, index2) in prodMstList.filter((prod) => prod.catCd == cate.cdVl1 )" 
                    :key="index2"
                    :class="{'checkBtn': prod.selected}"
                    @click="prodPick(prod, prod.salegropCd)"
                    type="button">{{prod.prdtnm}}</button>
                </div>
            </div>

                    <!-- :class="{'checkBtn': item.selected}"
                    @click="prodChoice(item,index)" -->
<!--             
            <swiper class="swiper pdCat" :options="product" ref="prdoList">
                <swiper-slide v-for="(cate, index) in cateList" :key="index">
                    <h6>{{cate.cdNm}}</h6>
                    <ul>
                        <li v-for="(prod, index2) in prodMstList.filter((prod) => prod.catCd == cate.cdVl1 )" :key="index2" @click="prodPick(prod.salegropCd)" :class="{'current':prod.pick, 'symbol':prod.bcnmYn == 'Y'? true : false }">{{prod.prdtnm}}</li>
                    </ul>
                </swiper-slide>
            </swiper>             -->
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="black" @click="close()">취소</button>
        <button type="button" class="red" @click="returnSelectedProdList">선택</button>
    </div>
</div>
</template>

<script>
export default {
  data() {
      return{
        cateList: [],
        prodMstList: [],
        selectedProdList: [],
        slideMenu: {
          slidesPerView: 'auto'
        },
        
        catIdx : 0,
        cate:{
            cdNm: '',
            cdVl1: '',
        },

        pick: null,
      };
  },
  methods: {        
      catChoose: function(item, _index){ // 카테고리 선택
        this.catIdx = _index
        this.cate.cdNm = item.cdNm
        this.cate.cdVl1 = item.cdVl1        
      },      
      prodPick: function(item,salegropCd){
        var findIndex = this.prodMstList.findIndex((prod) => prod.salegropCd == salegropCd);
        this.prodMstList[findIndex].pick = !this.prodMstList[findIndex].pick;

        var findIndex2 = this.selectedProdList.findIndex((prod) => prod.salegropCd == salegropCd);
          
        if(findIndex2 > -1){
            this.selectedProdList.splice(findIndex2, 1);
            //console.log('del : '+ salegropCd);
        }else{
            if(this.selectedProdList.length > 4){
                alert("상품은 최대 5개까지 선택가능합니다.");
                return;
            }
            this.selectedProdList.push(this.prodMstList[findIndex]);
            //console.log('input : '+ salegropCd);
        }
        this.$set(item, 'selected', !item.selected);   

        //console.log('selectedProdList : '+this.selectedProdList);
      },
      returnSelectedProdList: function(){
        var child = {
            name: "cstmr-detail-search-selectedprodlist",
            data: this.selectedProdList
        };
        // console.log("ProdSearch.vue child",child);
        this.$utils.nativeIf.outbound.sendChildData(child);
      },
      setSelectedProdListToProdMstList: function(){
            for(var i=0; i<this.selectedProdList.length; i++){
                for(var j=0; j<this.prodMstList.length; j++){
                    if(this.selectedProdList[i].salegropCd == this.prodMstList[j].salegropCd){
                        this.prodMstList[j].pick = !this.prodMstList[j].pick;
                        this.$set(this.prodMstList[j], 'selected', !this.prodMstList[j].selected);  
                    }
                }
            }
      },
    close: function(){
        window.app.$root.$utils.nativeIf.outbound.close(false);
    },
  },
  created() {
    var that = this;
    this.$api.myCstmr.getProdMstList()
    .then(function(res) {
        console.log("ProdSearch.vue res.cateList",res.cateList);
        console.log("ProdSearch.vue res.prodMstList",res.prodMstList);
        that.cateList = res.cateList;
        that.prodMstList = res.prodMstList;
        that.cate.cdVl1 = res.cateList[0].cdVl1
        that.cate.cdNm = res.cateList[0].cdNm  

        that.setSelectedProdListToProdMstList();
    })
    .catch(function(error) {
        alert(error.rtMsg);
    }); 
  },
  mounted: function() { //  인스턴스가 마운트 된 직후    
    var parent = this.$store.getters.parent;
        if(parent.name == 'cstmr-prod-search-param'){  // 부모창에서 받은 고객정보.
        console.log("ProdSearch.vue mounted parent.data", parent.data);
            if(null != parent.data.selectedProdList && parent.data.selectedProdList.length > 0){
                this.selectedProdList = parent.data.selectedProdList;                
            }
            
            // 넘어온 파라메터 초기화
            parent = {
                name: 'cstmr-prod-search-param',
                data: {
                    selectedProdList: ""
                }
            };
            this.$store.commit("SET_UI_PARENT", parent);
            

        }
  }	
};
</script>
